export default __webpack_public_path__ + "0a963c06088e7bb891f7adf54ae9c0f1.png";